import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

import { COMPANY, LEGAL_NOTICE, LEGAL_POLICIES } from '@shared/utils/legal.content';

/**
 * The compliance notice + the five required policies, as one block.
 *
 * Shared because three surfaces show exactly this: the public /legal page, the vendor profile's
 * Legal modal and the customer profile's Legal modal. Policies open one at a time so the block
 * reads as a short list rather than a wall of text. Copy comes from `legal.content.ts`.
 */
@Component({
  selector: 'app-legal-notice',
  standalone: true,
  styleUrl: './legal-notice.component.scss',
  imports: [CommonModule],
  templateUrl: './legal-notice.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegalNoticeComponent {
  readonly notice = LEGAL_NOTICE;
  readonly policies = LEGAL_POLICIES;
  readonly company = COMPANY;

  /** Which policy is expanded — one at a time, none on arrival. */
  readonly openKey = signal<string | null>(null);

  toggle(key: string): void {
    this.openKey.set(this.openKey() === key ? null : key);
  }
}
